import { Alert, Progress } from "@heroui/react";

interface EncryptionSetupProgressProps {
  progress: number;
  progressMessage: string;
}

export function EncryptionSetupProgress({ progress, progressMessage }: EncryptionSetupProgressProps) {
  return (
    <div className="space-y-2">
      <Alert
        color="warning"
        title="Encryption in progress"
        description="Please do not close the app or navigate away until encryption is complete. This process may take a few moments depending on the amount of data."
      />
      <Progress
        aria-label="Encryption progress"
        value={progress}
        color="primary"
        showValueLabel={true}
        className="w-full"
      />
      {progressMessage && <p className="text-default-500 text-sm">{progressMessage}</p>}
    </div>
  );
}
